import { apiClient } from '../../services/apiClient';

export type BadgeCode = 'B-01' | 'B-02' | 'B-03' | 'B-04' | 'B-05' | 'B-06';
export type BadgeState = 'ACQUIRED' | 'LOCKED';

export interface BadgeExerciseReference {
  id: string;
  title: string;
}

export interface BadgeRule {
  badgeCode: BadgeCode;
  name: string;
  exercise: BadgeExerciseReference | null;
}

export interface CollectibleBadge {
  badgeCode: BadgeCode;
  name: string;
  description: string;
  altText: string;
  state: BadgeState;
  earnedAt: string | null;
  imageUrl: string;
  triggerExercise: BadgeExerciseReference | null;
}

export interface PublicBadgeSummary {
  badgeCode: BadgeCode;
  name: string;
  altText: string;
  imageUrl: string;
}

export interface NewlyAwardedBadge {
  badgeCode: BadgeCode;
  name: string;
  imageUrl: string;
}

export interface BadgeSelectionResponse {
  selectedBadgeCode: BadgeCode | null;
}

export function getBadgeRules(courseId: string): Promise<BadgeRule[]> {
  return apiClient(`/courses/${encodeURIComponent(courseId)}/badge-rules`);
}

export function putBadgeRule(
  courseId: string,
  badgeCode: BadgeCode,
  exerciseId: string,
): Promise<BadgeRule> {
  return apiClient(`/courses/${encodeURIComponent(courseId)}/badge-rules/${badgeCode}`, {
    method: 'PUT',
    body: JSON.stringify({ exerciseId }),
  });
}

export function deleteBadgeRule(courseId: string, badgeCode: BadgeCode): Promise<void> {
  return apiClient(`/courses/${encodeURIComponent(courseId)}/badge-rules/${badgeCode}`, {
    method: 'DELETE',
  });
}

export function setBadgeCollectionConsent(consented: boolean): Promise<void> {
  return apiClient('/me/badge-collection-consent', {
    method: 'PUT',
    body: JSON.stringify({ consented }),
  });
}

export function setBadgeSelection(
  courseId: string,
  badgeCode: BadgeCode | null,
): Promise<BadgeSelectionResponse> {
  return apiClient(`/courses/${encodeURIComponent(courseId)}/badge-selection`, {
    method: 'PUT',
    body: JSON.stringify({ badgeCode }),
  });
}
